import React, { useState, useEffect } from 'react';
import { get, post } from '../helper/httpClient';
import { endPoints } from '../constants/endPoints';
import "flatpickr/dist/themes/light.css";
import Flatpickr from "react-flatpickr";
import moment from 'moment';
import tz from 'moment-timezone';
import { Redirect } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import FilledInput from '@material-ui/core/FilledInput';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Button from '@material-ui/core/Button';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import GenericNotFound from '../components/GenericNotFound';
import TextField from '@material-ui/core/TextField';
import { css } from "@emotion/core";
import BeatLoader from "react-spinners/BeatLoader";
import SquareLoader from "react-spinners/SquareLoader";
import ScaleLoader from "react-spinners/ScaleLoader";


const useStyles = makeStyles(theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing(1),
        width: '75%',
        alignContent: 'center'
    },
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '75%',
        },
    }
}));



let timezone = moment.tz.guess();
let timezone_abbr = moment.tz(timezone).zoneAbbr();
// let timezone_abbr = moment().tz(timezone).format('z');
if(timezone == 'Asia/Calcutta') {
    timezone = 'Asia/Kolkata';
}

//Daylight Saving ---Normal TimeZone
if (timezone_abbr == 'PDT') {
    timezone_abbr = 'PST';
} else if (timezone_abbr == 'EDT') {
    timezone_abbr = 'EST';
} else if (timezone_abbr == 'CDT') {
    timezone_abbr = 'CST';
} else if (timezone_abbr == 'MDT') {
    timezone_abbr = 'MST';
} else if (timezone_abbr == 'AKDT') {
    timezone_abbr = 'AKST';
} else if (timezone_abbr == 'CEST') {
    timezone_abbr = 'CET';
}

let dt = new Date();
let dateString = dt.getFullYear() + "/" + (dt.getMonth() + 1) + "/" + dt.getDate()
let selectedDateMoment = moment(dateString);
let selectedDay = selectedDateMoment.day();

let projectId = null;
let userId = null;
let userFname = null;
let userLname = null;


function Scheduler(props) {
    // let url = window.location.pathname;
    let url = window.location.hash;
    let urlPart = url.split('/');
    if (Array.isArray(urlPart) && urlPart.length == 2) {
        urlPart = urlPart[1].split('-');
        if (Array.isArray(urlPart) && urlPart.length >= 2) {
            projectId = urlPart[0];
            userId = urlPart[1];
            // userFname = urlPart[2];
            // userLname = urlPart.slice(3).join('-');
            if (projectId == null || projectId == '' || userId == null || userId == '') {
                window.location.replace("/");
            }

        } else {
            window.location.replace("/");
        }
    } else {
        // window.location.replace("/");
    }
    let initialState = {
        projectId: projectId,
        mounted: false,
        id: null,
        name: '',
        duration: null,
        description: '',
        submitbtn: '',
        thankyouMsg: '',
        workflow_id: null,
        status_name: '',
        fields: null,
        availableSlots: [],
        logo: '',
        thank_you_msg: '',
        submit_button_label: '',
        location: '',
        scheduler_booked_slots: [],
        selectedDay: selectedDay,
        selectedDate: new Date(),
        selectedDateMoment: selectedDateMoment,
        min_advance_notice: null,
        min_advance_notice_type: null,
        selected_date_time: null,
        invalidUrl: false,
        step: 1,
        savingForm: false,
        bookingError: false,
        logoLoader: false,

    }
    let [state, setState] = useState(initialState);

    useEffect(() => {
        loadSchedulerData();
    }, [state.projectId]);

    let saveSchedulerData = (fields, field_names) => {
        let params = {
            schedular_id: state.id,
            schedular_name: state.name,
            description: state.description,
            selected_date_time: state.selected_date_time,
            duration: state.duration,
            project_id: projectId,
            user_id: userId,
            workflow_id: state.workflow_id,
            status_name: state.status_name,
            min_advance_notice: state.min_advance_notice,
            min_advance_notice_type: state.min_advance_notice_type,
            // user_fname: userFname,
            // user_lname: userLname,
            fields: fields,
            filledData: null,
            timezone: timezone_abbr,
            field_names: field_names
        }
        setState({ ...state, savingForm: true });
        let promise = Promise.resolve(post(endPoints.SCHEDULER.SAVE, params));
        promise.then((response) => {
            if (response.status == 0 && response.data.isSaved == true) {
                setState({ ...state, step: 3, savingForm: false });
            } else if (response.status == 0 && response.data.isSaved == false && response.data.hasOwnProperty('isTimeSloteBooked') && response.data.isTimeSloteBooked) {
                updateParentState({ bookingError: true });
            } else if (response.status == -1 || response.data.isSaved == false) {
                alert("Unable to Save!!");
            }
        });
    }

    function loadSchedulerData(reload = false) {
        let params = {
            project_id: projectId,
            user_id: userId,
            timezone: timezone_abbr
            // user_fname: userFname,
            // user_lname: userLname
        }
        try {
            let promise = Promise.resolve(get(endPoints.SCHEDULER.GET, params));
            promise.then((response) => {
                if (response.status == 0) {
                    let data = response.data.appointment_scheduler_info;
                    let responseData = {
                        id: data.id,
                        mounted: true,
                        logo: data.logo_url === undefined ? '/images/soffront_logo.png' : data.logo_url,
                        name: data.appointment_name,
                        duration: data.duration,
                        workflow_id: data.workflow_id,
                        status_name: data.status_name,
                        availableSlots: data.sftr_scheduler_availability,
                        description: data.description,
                        location: data.location,
                        fields: data.sftr_scheduler_fields,
                        thank_you_msg: data.thank_you_msg,
                        submit_button_label: data.submit_button_label,
                        scheduler_booked_slots: data.scheduler_booked_slots,
                        min_advance_notice: data.min_advance_notice,
                        min_advance_notice_type: data.min_advance_notice_type,
                        logoLoader: true,
                    }
                    let updatedState = {
                        ...state,
                        ...responseData
                    }
                    if (reload) {
                        updatedState = {
                            ...initialState,
                            ...responseData
                        }
                    }
                    setState(updatedState);
                } else if (response.status == -1) {
                    // window.location.replace("/");
                    setState({
                        ...state,
                        invalidUrl: true
                    });
                }

            });
        } catch (error) {
            console.log(error);
        }

    }

    let handleBack = (fields) => {
        setState({ ...state, step: 1, filledData: fields });
    }

    let handleDateChange = (date) => {
        let selectedDateMoment = moment(date[0]);
        let selectedDay = selectedDateMoment.day();
        setState({
            ...state,
            selectedDay: selectedDay,
            selectedDate: date,
            selectedDateMoment: selectedDateMoment
        });
    }

    let handleTimeSlotClick = (datetime) => {
        setState({ ...state, step: 2, selected_date_time: datetime });
    }

    let updateParentState = (newState) => {
        if (newState.hasOwnProperty('bookingError') && newState.bookingError == false) {
            loadSchedulerData(true);
        } else {
            setState({ ...state, ...newState });
        }
    }

    if (state.invalidUrl) {
        return (<GenericNotFound msg={"Sorry, it doesn't look like this is a valid scheduling page."} />);
    }

    return (
        <div className="container">
            <Header logo={state.logo} mounted={state.logoLoader} />
            <Body data={state}
                handleDateChange={handleDateChange}
                handleTimeSlotClick={handleTimeSlotClick}
                saveSchedulerData={saveSchedulerData}
                handleBack={handleBack}
                updateParentState={updateParentState}
            />
            <Footer />
        </div>
    );
}

class Header extends React.PureComponent {
    render() {
        return (
            <div className="header">
                <div className="logo">
                    {this.props.mounted ? <img src={this.props.logo} alt="Logo" style={{ paddingLeft: 0, float: 'left', maxWidth: 100, maxHeight: 60 }} /> : <SquareLoader
                        size={60}
                        color={"#87CEEB"}
                        loading={true}
                    />}
                </div>
            </div>
        );
    }
}

function Body(props) {
    let dt = new Date();
    let dateString = dt.getFullYear() + "-" + (dt.getMonth() + 1) + "-" + dt.getDate();
    let mindate = dateString;

    let flatPickerConfig = {
        inline: true,
        minDate: mindate,
    }
    let headerHeight = props.data.location == '' ? '60px' : '70px';
    
    if (props.data.bookingError) {
        return (
            <div className="scheduler-body">
                <div className="scheduler-content" style={{ position: 'relative' }}>
                    <div className="booking-error">
                        <div style={{ fontWeight: 600, fontSize: 16, wordWrap: 'break-word', lineHeight: 1.6, marginBottom: 10, color: 'black' }}>An error occurred while booking.</div>
                        <div style={{ fontSize: 14, marginBottom: 20 }}>This time slot was not an available option.</div>
                        <Button variant="contained" onClick={props.updateParentState.bind(this, { bookingError: false, step: 1 })} style={{ backgroundColor: '#EE5624', color: '#FFFFFF' }}>
                            Try Again
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="scheduler-body">
            {props.data.mounted ?
                <div className="scheduler-content">
                    <div>
                        <div className="step1-header" style={{height: headerHeight}}>
                            <div className="h-1">{props.data.name}</div>
                            <Duration show={true} duration={props.data.duration} />
                            {props.data.location != '' && <div style={{fontSize: 12}}>{props.data.location}</div>}
                        </div>
                        {props.data.step == 1 && <div className="step1-body">
                            <div>
                                <div style={{ width: '60%', float: 'left', paddingTop: 30 }}>
                                    <Flatpickr
                                        value={props.data.selectedDate}
                                        options={flatPickerConfig}
                                        onChange={props.handleDateChange}
                                    />
                                    <div style={{ marginTop: 20, float: 'right', marginRight: 45, fontSize: 14 }}>{timezone}</div>
                                </div>
                                <div style={{ width: '40%', float: 'right' }}>
                                    <div className="h-2" style={{ marginBottom: 15, textAlign: 'center' }}>{props.data.selectedDateMoment.format('MMMM D, YYYY')}</div>
                                    <TimeSlots data={props.data} handleTimeSlotClick={props.handleTimeSlotClick} />
                                </div>
                                <div style={{ clear: 'both' }}></div>
                            </div>
                        </div>
                        }
                        {(props.data.step == 2 || props.data.step == 3) && <div className="step2-body">
                            <div className="left-section">
                                 <ScheduledTime time={props.data.selected_date_time} />
                            </div>
                            <div className="right-section">
                                {props.data.step == 2 &&
                                    <SchedulerForm data={props.data}
                                        saveSchedulerData={props.saveSchedulerData}
                                        handleBack={props.handleBack}
                                        updateParentState={props.updateParentState}
                                    />
                                }
                                {props.data.step == 3 &&
                                    <ThanksMsg msg={props.data.thank_you_msg} />
                                }
                            </div>
                        </div>
                        }

                    </div>
                </div>
                :
                <div className="loader-div">
                    <BeatLoader
                        size={15}
                        color={"#0BB5FF"}
                        loading={true}
                    />
                </div>
            }
        </div>
    );
}

function Footer() {
    return (<div className="footer"><span>Powered By </span><a target="_blank" href="http://www.soffront.com/" style={{textDecoration: 'none'}}><span className="sf-1">SOF</span><span className="sf-2">FRONT</span></a></div>);
}

function ScheduledTime(props) {
    let scheduledDateTime = moment(props.time);
    let scheduledDate = scheduledDateTime.format('dddd, MMMM DD, YYYY');
    let scheduledTime = scheduledDateTime.format('h:mm A');
    return (
        <div style={{ fontSize: 14, fontWeight: 'normal', lineHeight: 1.6 }}>
            <div>Selected Time:</div>
            <div>{scheduledDate}</div>
            <div>{scheduledTime + " " + timezone} </div>
        </div>
    );
}

function Description(props) {
    return (
        <div style={{ marginTop: 30, maxHeight: 300, overflow: 'auto', fontSize: 14, textAlign: 'justify', lineHeight: 1.6 }}>
            {props.description}
        </div>);
}

function TimeSlots(props) {
    let validTimeSlot = () => {
        var now = moment();
        var selectedDateStrig = props.data.selectedDateMoment.format('YYYY-MM-DD HH:mm:ss');
        var currentSlot = moment(selectedDateStrig);
        var currentSlotColne = moment(selectedDateStrig);
        var currentSlotEnd = currentSlotColne.add(props.data.duration, 'minutes');
        let bookedSlotMomentStart = null;
        let bookedSlotMomentEnd = null;
        if (currentSlot.diff(now) <= 0) {
            return false;
        } else {
            let bookedSlots = props.data.scheduler_booked_slots.filter((el) => {
                let keys = Object.keys(el);
                let key = keys[0];
                return key == props.data.selectedDateMoment.format('YYYY-MM-DD');
            });
            for (let i = 0; i < bookedSlots.length; i++) {
                let bookedDateTimeObj = bookedSlots[i];
                let keys = Object.keys(bookedDateTimeObj);
                let key = keys[0];
                let currentObj = bookedDateTimeObj[key];
                let bookedSlotMoment = null;
                let date = key;
                let start_time = currentObj.str_time;
                let end_time = currentObj.end_time;
                bookedSlotMomentStart = moment(date + ' ' + start_time);
                bookedSlotMomentEnd = moment(date + ' ' + end_time);
                if (currentSlot <= bookedSlotMomentStart && currentSlotEnd >= bookedSlotMomentEnd) {
                    return false;
                    break;
                } else if (currentSlot >= bookedSlotMomentStart && currentSlot < bookedSlotMomentEnd) {
                    return false;
                    break;
                }
                else if (bookedSlotMomentStart < currentSlotEnd && bookedSlotMomentEnd > currentSlotEnd) {
                    return false;
                    break;
                }
            }
        }
        bookedSlotMomentStart = null;
        bookedSlotMomentEnd = null;
        return true;
    }
    let getTimeSlots = () => {
        let data = props.data;
        let availableTimeObj = null;
        let selectedDay = data.selectedDay;
        if (selectedDay == 0) {
            selectedDay = 7;
        }

        let dt = new Date();
        let dateString = dt.getFullYear() + "/" + (dt.getMonth() + 1) + "/" + dt.getDate()
        let momentToday = moment(dateString);
        let today_no = momentToday.day();

        let availableTimeObjList = data.availableSlots.filter(function (el) {
            return el.day_id == selectedDay;
        });
        
        if (availableTimeObjList != null && availableTimeObjList.length >= 1) {
            if(availableTimeObjList.length == 2) {
                if(availableTimeObjList[1].from_time == '00:00') {
                    let temp = availableTimeObjList[1];
                    availableTimeObjList[1] = availableTimeObjList[0];
                    availableTimeObjList[0] = temp;
                }
            }
            let timeSlots = [];
            availableTimeObjList.forEach(function(availableTimeObj) {
                let startTime=moment(availableTimeObj.from_time, "hh:mm");
                let endTime=moment(availableTimeObj.to_time, "hh:mm");
                let duration = moment.duration(endTime.diff(startTime));
                let time_duration = parseInt(duration.asMinutes());
                let from_time = availableTimeObj.from_time;
                if (time_duration >= data.duration) {
                    let max_length = Math.floor(time_duration / data.duration);
                    let selectedDateMoment = data.selectedDateMoment;
                    selectedDateMoment.set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
                    
                    let form_time_split = from_time.split(':');
                    selectedDateMoment.add(form_time_split[0], 'hours');
                    selectedDateMoment.add(form_time_split[1], 'minutes');
        
                    if (validTimeSlot()) {
                        timeSlots.push(selectedDateMoment.clone());
                    }
        
                    for (var i = 0; i < max_length - 1; i++) {
                        selectedDateMoment.add(data.duration, 'minutes');
                        if (!validTimeSlot()) {
                            continue;
                        }
                        timeSlots.push(selectedDateMoment.clone());
                    }
                }
            });
            if (timeSlots.length > 0) {
                return timeSlots.map((date, index) => {
                    return (<div className="slot" key={index}><button  onClick={props.handleTimeSlotClick.bind(this, date.format("YYYY-MM-DD HH:mm:ss"))} className="slot-btn" value={date.format("YYYY-MM-DD HH:mm:ss")}>{date.format('hh:mm A')}</button></div>)
                });
            } else if (selectedDay == today_no) {
                return <div style={{ lineSpacing: 1.6, fontSize: 14, textAlign: 'center' }}>There are no available slots for today</div>
            } else {
                return <div style={{ lineSpacing: 1.6, fontSize: 14, textAlign: 'center' }}>There are no available slots for {props.data.selectedDateMoment.format('dddd')}</div>
            }
        } else {
            return <div style={{ lineSpacing: 1.6, fontSize: 14, textAlign: 'center' }}>There are no available slots for {props.data.selectedDateMoment.format('dddd')}</div>
        }
    }

    let timeSlots = getTimeSlots();
    return (
        <div className="time-slots">{timeSlots}</div>
    );
}

function Duration(props) {
    if (props.show) {
        return (
            <div style={{ marginTop: 0 }} >
                <i className="fa fa-clock-o" aria-hidden="true" style={{ marginTop: '3px', fontSize: '15px', marginRight: '5px' }}></i>
                <span style={{ fontSize: 14 }}>{props.duration} minutes</span>
            </div>
        );
    } else {
        return null;
    }
}

function SchedulerForm(props) {
    const classes = useStyles();
    let stateFields = {};
    if (props.data.filledData != null) {
        stateFields = props.data.filledData;
    } else {
        props.data.fields.map(field => {
            stateFields[field.field_name] = {
                value: '',
                error: false,
                required: field.required,
                field_name: field.field_name,
                field_type: field.field_type,
                errorText: '',
                fieldLabel: field.field_label
            };
        });
    }
    const [state, setState] = useState({ fields: stateFields, field_names: [] });

    let setFieldValue = (fieldName, event) => {
        state.fields[fieldName].value = event.target.value;
        state.fields[fieldName].error = false;
        state.fields[fieldName].errorText = '';
        setState({ ...state });
    }
    let getFields = () => {
        return props.data.fields.map(field => {
            let required = '';
            if (field.required) {
                required = ' (required)';
            }
            if (field.field_type == 201) {
                return (
                    <div>
                        <TextField
                            fullWidth
                            error={state.fields[field.field_name].error}
                            label={field.field_label + required}
                            value={state.fields[field.field_name].value}
                            helperText={state.fields[field.field_name].errorText}
                            onChange={setFieldValue.bind(this, field.field_name)}
                            InputLabelProps={{
                                style: {
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    width: '100%',
                                    textAlign: 'left'
                                    //color: 'green'
                                },
                                title: field.field_label + required
                            }}
                        />
                    </div>
                );
            } else if (field.field_type == 205) {
                return (<div style={{ marginTop: 10 }}>
                    <TextField
                        id="outlined-multiline-flexible"
                        label={field.field_label + required}
                        multiline
                        rows="6"
                        error={state.fields[field.field_name].error}
                        value={state.fields[field.field_name].value}
                        onChange={setFieldValue.bind(this, field.field_name)}
                        variant="outlined"
                    />
                </div>);
            }
            // else if (field.field_type == 207) {

            // }
            return null;
        });
    }

    let validateForm = () => {
        let isValid = true;
        for (let field in state.fields) {
            if ((state.fields[field].field_type == 201 || state.fields[field].field_type == 205) && state.fields[field].required == true && state.fields[field].value.trim() == '') {
                state.fields[field].error = true;
                isValid = false;
            } else if (state.fields[field].field_type == 201 && state.fields[field].field_name == 'email' && !isEmail(state.fields[field].value)) {
                state.fields[field].error = true;
                state.fields[field].errorText = 'Invalid Email';
                isValid = false;
            }
        }
        setState({ ...state });
        return isValid;
    }

    let handleSubmitForm = (timeSlot) => {
        if (validateForm()) {
            let now = moment();
            let timeSoltMoment = moment(timeSlot);
            if (timeSoltMoment.diff(now) < 0) {
                props.updateParentState({ bookingError: true });
                return false;
            }
            let fields = {};
            for (let [key, val] of Object.entries(state.fields)) {
                state.field_names.push({name:key, label:val.fieldLabel});
                fields[key] = val.value;
            }
            props.saveSchedulerData(fields, state.field_names);
        }
    }

    let handleBack = () => {
        props.handleBack(state.fields);
    }

    let fields = getFields();
    let saveButtonStyle = { marginLeft: 10, backgroundColor: '#EE5624', color: '#FFFFFF' };
    let backButtonStyle = { backgroundColor: '#5A6268' };
    if(props.data.savingForm){
        saveButtonStyle = {...saveButtonStyle, backgroundColor: '#F8B6A0' };
        backButtonStyle = {backgroundColor: '#A0A7AC' };
    }
    return (
        <div style={{ width: '98%', }}>
            <div style={{ fontSize: 18, marginLeft: 65, align: 'left', fontWeight: 600, }}>Enter Your Details</div>
            <div style={{ maxHeight: 280, overflow: 'auto', textAlign: 'center' }}>
                <form className={classes.root} noValidate autoComplete="off">
                    {fields}
                </form>

            </div>
            <div style={{ float: 'right', marginTop: 20, marginRight: 65 }}>
                <div style={{ display: 'inline', float: 'left' }}>
                    <Button variant="contained" color="secondary" onClick={handleBack} disabled={props.data.savingForm} style={backButtonStyle}>
                        Back
                    </Button>
                </div>
                <div style={{ display: 'inline', float: 'left' }}>
                    <Button variant="contained" color="#EE5624" onClick={handleSubmitForm.bind(this, props.data.selected_date_time)} disabled={props.data.savingForm} style={saveButtonStyle}>
                        {props.data.submit_button_label}
                    </Button>
                </div>
                {props.data.savingForm && <div style={{ display: 'inline', float: 'left', marginTop: 8 }}><ScaleLoader
                    height={15}
                    width={4}
                    radius={2}
                    margin={2}
                    color={"#0BB5FF"}
                    loading={true}
                /></div>
                }
            </div>
        </div>
    );
}

function ThanksMsg(props) {
    return (<div>
        <div style={{ fontSize: 20, marginBottom: 20 }}>Thank You</div>
        <div>{props.msg}</div>
    </div>);
}

function isEmail(email) {
    let isValid = true;
    let emailregstr = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,})+$/;
    let result = -1;
    result = email.search(emailregstr);
    if (result == "-1") {
        isValid = false;
        return;
    }
    return isValid;
}

export default Scheduler;